// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__mJL-a","disabled":"FileBtn_disabled__R6kZ6","warn":"FileBtn_warn__HMQYP","fade":"FileBtn_fade__s-jgG"};